import { toast } from 'react-toastify';

const announceToLiveRegion = (msg, urgent = false) => {
  const id = urgent ? 'toast-live-assertive' : 'toast-live-polite';
  const el = document.getElementById(id);
  if (!el || typeof msg !== 'string') return;
  el.textContent = '';
  requestAnimationFrame(() => { el.textContent = msg; });
};

export const success = msg => {
  toast.success(msg, {
    position: toast.POSITION.TOP_RIGHT,
    role: 'status',
  });
  announceToLiveRegion(msg, false);
};

export const warning = msg => {
  toast.warn(msg, {
    position: toast.POSITION.TOP_RIGHT,
  });
  announceToLiveRegion(msg, true);
};

export const error = (msg, id) => {
  toast.error(msg, {
    position: toast.POSITION.TOP_RIGHT,
    toastId: id,
  });
  announceToLiveRegion(msg, true);
};

export const info = (msg, options) => {
  toast.info(msg, {
    position: toast.POSITION.TOP_RIGHT,
    role: 'status',
    ...options,
  });
  announceToLiveRegion(msg, false);
};

export const defaultToast = msg => {
  toast(msg, {
    position: toast.POSITION.TOP_RIGHT,
    className: 'toast-dark',
  });
  announceToLiveRegion(msg, false);
};

export const failed = msg => {
  toast.error(msg, {
    position: toast.POSITION.BOTTOM_CENTER,
  });
  announceToLiveRegion(msg, true);
};

export const accepted = msg => {
  toast.success(msg, {
    position: toast.POSITION.BOTTOM_CENTER,
    role: 'status',
  });
  announceToLiveRegion(msg, false);
};

export const disconnected = msg => {
  toast.error(msg, {
    position: toast.POSITION.BOTTOM_CENTER,
    autoClose: false,
  });
  announceToLiveRegion(msg, true);
};

export const offline = (msg, options) => {
  toast.error(msg, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: false,
    ...options
  });
  announceToLiveRegion(msg, true);
};

export const clear = () => {
  toast.dismiss();
};

export const clearById = (id) => {
  toast.dismiss(id);
};

export const updateToSuccess = (id, options) => {
  toast.update(id, {
    type: toast.TYPE.SUCCESS,
    position: toast.POSITION.TOP_RIGHT,
    ...options,
  });
}

const Toast = {
  success,
  warning,
  error,
  info,
  failed,
  accepted,
  defaultToast,
  disconnected,
  offline,
  clear,
  clearById,
  updateToSuccess
};

export default Toast;
